import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { I18nService } from '../../services/i18n.service';

interface Project {
  id: number;
  title: string;
  description: string;
  image: string;
  technologies: string[];
  liveUrl?: string;
  githubUrl?: string;
}

@Component({
  selector: 'app-cases',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cases.component.html',
  styleUrl: './cases.component.scss'
})
export class CasesComponent implements OnInit {
  projects: Project[] = [
    {
      id: 1,
      title: 'E-Commerce Platform',
      description: 'Full-stack e-commerce solution with admin panel, payment integration, and inventory management.',
      image: 'assets/images/project1.jpg',
      technologies: ['Angular', '.NET Core', 'PostgreSQL', 'Stripe', 'Docker'],
      liveUrl: 'https://example.com',
      githubUrl: 'https://github.com/example'
    },
    {
      id: 2,
      title: 'Task Management App',
      description: 'Collaborative task management application with real-time updates and team collaboration features.',
      image: 'assets/images/project2.jpg',
      technologies: ['React', 'Node.js', 'MongoDB', 'Socket.io', 'AWS'],
      liveUrl: 'https://example.com'
    },
    {
      id: 3,
      title: 'Restaurant Management System',
      description: 'Complete restaurant management solution with POS, inventory, staff management, and analytics.',
      image: 'assets/images/project3.jpg',
      technologies: ['Vue.js', 'Laravel', 'MySQL', 'Redis', 'Bootstrap']
    }
  ];

  constructor(public i18n: I18nService) {}

  ngOnInit(): void {
    this.i18n.initializeLanguage();
  }

  viewProject(project: Project): void {
    // Implement project details modal or navigation
    console.log('Viewing project:', project);
  }
}
